import React, { useEffect, useState } from "react";

export default function FloatingSubscribeButton({ hidden = false }) {
  const [label, setLabel] = useState("Subscribe");
  const [ctaHidden, setCtaHidden] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    let ctaObserver = null;
    let bodyObserver = null;

    const syncLabel = () => {
      const primaryCta = document.getElementById("subscription-primary-cta");
      const nextLabel =
        primaryCta?.dataset?.floatingLabel?.trim() ||
        primaryCta?.textContent?.trim() ||
        "Subscribe";

      setLabel(nextLabel);
      setCtaHidden(primaryCta?.dataset?.floatingHidden === "1");
    };

    const attachObserver = () => {
      const primaryCta = document.getElementById("subscription-primary-cta");
      if (!primaryCta || typeof MutationObserver === "undefined") {
        syncLabel();
        return Boolean(primaryCta);
      }

      syncLabel();

      ctaObserver = new MutationObserver(syncLabel);
      ctaObserver.observe(primaryCta, {
        attributes: true,
        attributeFilter: ["data-floating-label", "data-floating-hidden"],
        childList: true,
        characterData: true,
        subtree: true,
      });

      return true;
    };

    if (!attachObserver() && typeof MutationObserver !== "undefined") {
      bodyObserver = new MutationObserver(() => {
        if (attachObserver()) {
          bodyObserver.disconnect();
          bodyObserver = null;
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    return () => {
      ctaObserver?.disconnect();
      bodyObserver?.disconnect();
    };
  }, []);

  if (hidden || ctaHidden) return null;

  return (
    <button
      id="subscription-fab"
      data-bottom-clearance-gap="18"
      type="button"
      onClick={() => {
        const primaryCta = document.getElementById("subscription-primary-cta");
        if (primaryCta) {
          primaryCta.click();
          return;
        }
        window.dispatchEvent(new CustomEvent("vg-subscription-cta-click"));
      }}
      className="absolute left-1/2 -top-16 z-20 flex h-12 min-w-[196px] max-w-[calc(100vw-40px)] -translate-x-1/2 items-center justify-center rounded-full bg-[#0073FF] px-6 text-[0.92rem] font-semibold whitespace-nowrap text-white shadow-xl lg:hidden"
    >
      {label}
    </button>
  );
}
